module.exports = __webpack_public_path__ + "img/login-logo.601de8db.jpg";